// extracted by mini-css-extract-plugin
export var cardSelected = "_gi-2";
export var image = "_gi-1";
export var table = "_gi-0";